/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import { Link } from 'react-router-dom';


class ProjectCard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            project: props.project,
            loading: true
        }
    }

    componentDidMount() {
        this.setState({
        loading: false
        });
        
    }

    render() {
        return (
            // <div className="container col-xl-12 col-lg-12 col-md-12 col-sm-6 col-xs-12" key={this.state.project.id}>
            <div className="container col-xl-4 col-lg-6 col-md-6 col-sm-6 col-xs-12" key={this.state.project.id}>
                <div className="project-card-custom container zoom">
                    <Link to={`/projects/${this.state.project.id}`}>

                        <h3
                            style={{
                                color: 'var(--ink)',
                                fontWeight: '800',
                                fontSize: '1.3em',
                            }}
                        >
                            {this.state.project.title}
                        </h3>
                        <h5>{this.state.project.subtitle}</h5>
                        <hr />
                        <p
                            style={{
                                color: 'var(--brand)',
                                fontFamily: 'Courier',
                                fontWeight: '600',
                                fontSize: '0.75em',
                                lineHeight: '1.4',
                                margin: 0,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                display: '-webkit-box',
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: 'vertical',
                            }}
                        >
                            {this.state.project.technology} <span style={{color:'var(--muted)'}}>|</span> {this.state.project.skill}
                        </p>

                        {/* <h5><FontAwesomeIcon icon={faCode} color="black" /> {this.state.project.technology}</h5>
                        <h5><FontAwesomeIcon icon={faFire} color="black" /> {this.state.project.skill}</h5> */}
                        {/* <h6>#{this.state.project.id}</h6> */}
                    </Link>
                </div>
            </div>
        )
    }
}

export default ProjectCard;